import React from 'react';
import { SubscribeForm } from './Form';
import { useSubscribeEmail } from 'hooks/useSubscribeEmail';

type Props = {
  /**
   * TODO: Improve this type
   * I tried to get the right types from ZDS using
   * Pick<TextInputProps, 'color'> but that didn't work.
   */
  inputBackgroundColor: 'grey100' | 'white';
  sectionToTrack: string;
};

export const SubscribeFormContainer = ({
  inputBackgroundColor,
  sectionToTrack,
}: Props) => {
  const { error, loading, success, submitEmail } = useSubscribeEmail();

  return (
    <SubscribeForm
      inputBackgroundColor={inputBackgroundColor}
      loading={loading}
      error={error}
      sectionToTrack={sectionToTrack}
      success={success}
      onSubmit={submitEmail}
    />
  );
};
